import SummaryStat from './SummaryStat'

const activeSummaryByTab = {
  warehouses: 'Bodegas',
  items: 'Catálogo',
  recipes: 'Catálogo',
  stock: 'Inventario visible',
  operations: 'Ajustes',
  movements: 'Ajustes',
  uploads: 'Ajustes',
  'sales-note': 'Ajustes'
}

const InventoryHeader = ({ activeTab, hubStats }) => {
  const activeSummary = activeSummaryByTab[activeTab] || ''

  return (
    <section className='rounded-[22px] border border-slate-300 bg-gradient-to-br from-white via-white to-slate-50 p-3 shadow-[0_12px_28px_rgba(15,23,42,0.06)]'>
      <div className='flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between'>
        <div className='grid flex-1 grid-cols-2 gap-2 xl:grid-cols-4'>
          {hubStats.map(stat => (
            <SummaryStat
              key={stat.label}
              active={stat.label === activeSummary}
              label={stat.label}
              value={stat.value}
            />
          ))}
        </div>


      </div>
    </section>
  )
}

export default InventoryHeader
